import React from "react";
//import "./PageNotAccessible.css";

const PageNotAccessibleComponent = ({ onRetry }) => {
  return (
    <div className="pna-container">
      <div className="pna-card">
        <div className="pna-icon">📡</div>
        <h1>Page Not Accessible</h1>
        <p>
          We’re having trouble connecting to the server.
          <br />
          Please check your internet connection or try again later.
        </p>

        <button className="pna-button" onClick={onRetry}>
          Try Again
        </button>
      </div>
    </div>
  );
};

export default PageNotAccessibleComponent;

// Styles
const styles = `
  .pna-container {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #eef2ff, #f8fafc);
}

.pna-card {
  background: white;
  padding: 40px;
  width: 90%;
  max-width: 420px;
  text-align: center;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

.pna-icon {
  font-size: 48px;
  margin-bottom: 16px;
}

.pna-card h1 {
  margin-bottom: 12px;
  font-size: 24px;
  color: #1f2937;
}

.pna-card p {
  color: #6b7280;
  margin-bottom: 24px;
  line-height: 1.6;
}

.pna-button {
  padding: 12px 24px;
  background: #4f46e5;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.pna-button:hover {
  background: #4338ca;
}

`;

// Add styles to the document head
const styleElement = document.createElement("style");
styleElement.innerHTML = styles;
document.head.appendChild(styleElement);
